/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./resources/app.ts"
/*!**************************!*\
  !*** ./resources/app.ts ***!
  \**************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _components_Consent_Consent__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @components/Consent/Consent */ "./resources/scripts/components/Consent/Consent.ts");
/* harmony import */ var _components_Calculators_FlooringCalculator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @components/Calculators/FlooringCalculator */ "./resources/scripts/components/Calculators/FlooringCalculator.ts");
/* harmony import */ var _components_Calculators_CarpetCalculator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @components/Calculators/CarpetCalculator */ "./resources/scripts/components/Calculators/CarpetCalculator.ts");
/* harmony import */ var _components_Sample__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @components/Sample */ "./resources/scripts/components/Sample.ts");




var consent = new _components_Consent_Consent__WEBPACK_IMPORTED_MODULE_0__["default"]();
consent.init();
customElements.define("flooring-calculator", _components_Calculators_FlooringCalculator__WEBPACK_IMPORTED_MODULE_1__["default"]);
customElements.define("carpet-calculator", _components_Calculators_CarpetCalculator__WEBPACK_IMPORTED_MODULE_2__["default"]);
customElements.define("sample-upsell", _components_Sample__WEBPACK_IMPORTED_MODULE_3__["default"]);

/***/ },

/***/ "./resources/scripts/components/Calculators/CarpetCalculator.ts"
/*!**********************************************************************!*\
  !*** ./resources/scripts/components/Calculators/CarpetCalculator.ts ***!
  \**********************************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ CarpetCalculator)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CarpetCalculator = /*#__PURE__*/function (_HTMLElement) {
  function CarpetCalculator() {
    var _this;
    _classCallCheck(this, CarpetCalculator);
    _this = _callSuper(this, CarpetCalculator);
    _defineProperty(_this, "quantityPicker", void 0);
    _defineProperty(_this, "flooringAmount", void 0);
    _defineProperty(_this, "totalFlooringAmount", void 0);
    _defineProperty(_this, "priceFlooring", void 0);
    _defineProperty(_this, "lineItemSqm", void 0);
    _defineProperty(_this, "input", void 0);
    _defineProperty(_this, "inputButtons", void 0);
    _defineProperty(_this, "producturl", null);
    _defineProperty(_this, "pricePerSqm", 0);
    _defineProperty(_this, "variantWidth", 0);
    _this.updateCarpet = _this.updateCarpet.bind(_this);
    _this.handleInputButtonClick = _this.handleInputButtonClick.bind(_this);
    _this.initializeElements = _this.initializeElements.bind(_this);
    _this.addEventListeners = _this.addEventListeners.bind(_this);
    return _this;
  }
  _inherits(CarpetCalculator, _HTMLElement);
  return _createClass(CarpetCalculator, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.initializeElements();
      this.addEventListeners();
      this.updateCarpet();
    }
  }, {
    key: "initializeElements",
    value: function initializeElements() {
      var _this$dataset$product, _this$dataset$pricePe, _this$dataset$variant;
      this.quantityPicker = document.querySelector(".qty-input__input.input.gulvtappe");
      this.flooringAmount = this.querySelector("#flooring");
      this.totalFlooringAmount = this.querySelector("#total-amonunt-of-flooring");
      this.priceFlooring = this.querySelector("#price-flooring");
      this.lineItemSqm = this.querySelector("#lineitemsqm");
      this.input = this.querySelector(".wrapper.gulvtappe input");
      this.inputButtons = this.querySelectorAll(".wrapper.gulvtappe .input-button");
      this.producturl = (_this$dataset$product = this.dataset.producturl) !== null && _this$dataset$product !== void 0 ? _this$dataset$product : null;
      this.pricePerSqm = parseFloat((_this$dataset$pricePe = this.dataset.pricePerSqm) !== null && _this$dataset$pricePe !== void 0 ? _this$dataset$pricePe : "0") / 100; // Convert from cents to currency
      this.variantWidth = parseFloat((_this$dataset$variant = this.dataset.variantWidth) !== null && _this$dataset$variant !== void 0 ? _this$dataset$variant : "0");
    }
  }, {
    key: "rerenderComponent",
    value: function () {
      var _rerenderComponent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(variantId) {
        var productUrl, url, response, text, doc, newComponent, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              productUrl = this.producturl;
              if (productUrl) {
                _context.n = 1;
                break;
              }
              console.warn("CarpetCalculator reinit: missing product URL");
              return _context.a(2);
            case 1:
              url = "".concat(productUrl, "?variant=").concat(variantId);
              _context.n = 2;
              return fetch(url, {
                credentials: "same-origin"
              });
            case 2:
              response = _context.v;
              if (response.ok) {
                _context.n = 3;
                break;
              }
              console.warn("CarpetCalculator reinit: fetch failed", response.status, url);
              return _context.a(2);
            case 3:
              _context.n = 4;
              return response.text();
            case 4:
              text = _context.v;
              doc = new DOMParser().parseFromString(text, "text/html");
              newComponent = doc.querySelector("carpet-calculator");
              if (newComponent) {
                this.replaceWith(newComponent);
              }
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
              console.error("Error re-initializing CarpetCalculator component:", _t);
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[0, 5]]);
      }));
      function rerenderComponent(_x) {
        return _rerenderComponent.apply(this, arguments);
      }
      return rerenderComponent;
    }()
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this2 = this;
      document.addEventListener("on:variant:change", function (event) {
        var customEvent = event;
        var variant = customEvent.detail.variant;
        if (variant && variant.id) {
          _this2.rerenderComponent(variant.id.toString());
        }
      });
      if (this.flooringAmount) {
        this.flooringAmount.addEventListener("change", this.updateCarpet);
        if (this.input) {
          this.input.addEventListener("keyup", function () {
            _this2.updateCarpet();
          });
        }
        this.inputButtons.forEach(function (button) {
          button.addEventListener("click", _this2.handleInputButtonClick);
        });
      }
    }
  }, {
    key: "handleInputButtonClick",
    value: function handleInputButtonClick(evt) {
      var button = evt.currentTarget;
      if (!this.input) return;
      var inputVal = parseInt(this.input.value, 10);
      if (button.classList.contains("add")) {
        inputVal += 1;
      } else if (button.classList.contains("remove") && inputVal > 1) {
        inputVal -= 1;
      }
      this.input.value = inputVal.toString();
      this.updateCarpet();
    }
  }, {
    key: "updateCarpet",
    value: function updateCarpet() {
      if (!this.flooringAmount || !this.quantityPicker || !this.totalFlooringAmount) return;
      if (this.variantWidth <= 0) return;
      var flooringValue = parseFloat(this.flooringAmount.value);
      // Calculate sqm: (width in cm * length in cm) / 10000
      var sqmFlooring = Math.round(this.variantWidth * flooringValue / 100) / 100;
      var sqmFlooringRounded = Math.ceil(sqmFlooring * 10) / 10;
      // Update quantity and display
      if (sqmFlooringRounded <= 0) {
        this.quantityPicker.value = "10";
        this.totalFlooringAmount.innerHTML = "0.1";
      } else {
        this.quantityPicker.value = (sqmFlooringRounded * 10).toString();
        this.totalFlooringAmount.innerHTML = sqmFlooringRounded.toString();
      }
      // Update price
      if (this.priceFlooring && this.pricePerSqm > 0) {
        var totalFlooringPrice = this.pricePerSqm * sqmFlooringRounded;
        var totalFlooringPriceFormatted = totalFlooringPrice.toLocaleString("da-DK", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        this.priceFlooring.innerHTML = "".concat(totalFlooringPriceFormatted, " kr");
      }
      // Update line item
      if (this.lineItemSqm) {
        this.lineItemSqm.setAttribute("value", sqmFlooringRounded.toString());
      }
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _this3 = this;
      if (this.flooringAmount) {
        this.flooringAmount.removeEventListener("change", this.updateCarpet);
      }
      this.inputButtons.forEach(function (button) {
        button.removeEventListener("click", _this3.handleInputButtonClick);
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ },

/***/ "./resources/scripts/components/Calculators/FlooringCalculator.ts"
/*!************************************************************************!*\
  !*** ./resources/scripts/components/Calculators/FlooringCalculator.ts ***!
  \************************************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ FlooringCalculator)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var FlooringCalculator = /*#__PURE__*/function (_HTMLElement) {
  function FlooringCalculator() {
    var _this;
    _classCallCheck(this, FlooringCalculator);
    _this = _callSuper(this, FlooringCalculator);
    _defineProperty(_this, "totalAmountFloor", void 0);
    _defineProperty(_this, "sqmFloor", void 0);
    _defineProperty(_this, "packageAmount", void 0);
    _defineProperty(_this, "packageTotal", void 0);
    _defineProperty(_this, "pricePackageOutput", void 0);
    _defineProperty(_this, "amountSqm", void 0);
    _defineProperty(_this, "amountPackages", void 0);
    _defineProperty(_this, "amountPackagesText", void 0);
    _defineProperty(_this, "input", void 0);
    _defineProperty(_this, "inputButtons", void 0);
    _defineProperty(_this, "producturl", null);
    _defineProperty(_this, "packagePrice", 0);
    _defineProperty(_this, "sqmPerPackage", 0);
    _this.updateFlooring = _this.updateFlooring.bind(_this);
    _this.handleInputButtonClick = _this.handleInputButtonClick.bind(_this);
    _this.initializeElements = _this.initializeElements.bind(_this);
    _this.addEventListeners = _this.addEventListeners.bind(_this);
    return _this;
  }
  _inherits(FlooringCalculator, _HTMLElement);
  return _createClass(FlooringCalculator, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.initializeElements();
      this.addEventListeners();
      this.updateFlooring();
    }
  }, {
    key: "initializeElements",
    value: function initializeElements() {
      var _this$amountPackages, _this$dataset$product, _this$dataset$package, _this$dataset$sqmPerP;
      this.totalAmountFloor = document.querySelector(".qty-input__input.input.gulvinput");
      this.sqmFloor = this.querySelector("#sqm-floor");
      this.packageAmount = this.querySelector("#package-amount");
      this.packageTotal = this.querySelector("#total-amount-of-packages");
      this.pricePackageOutput = this.querySelector("#price-package");
      this.amountSqm = this.querySelector("#total-sqm");
      this.amountPackages = this.querySelector("#amountpackages");
      this.amountPackagesText = ((_this$amountPackages = this.amountPackages) === null || _this$amountPackages === void 0 ? void 0 : _this$amountPackages.innerText) || "Pakke";
      this.input = this.querySelector(".wrapper.gulv input");
      this.inputButtons = this.querySelectorAll(".wrapper.gulv .input-button");
      this.producturl = (_this$dataset$product = this.dataset.producturl) !== null && _this$dataset$product !== void 0 ? _this$dataset$product : null;
      this.packagePrice = parseFloat((_this$dataset$package = this.dataset.packagePrice) !== null && _this$dataset$package !== void 0 ? _this$dataset$package : "0") / 100; // Convert from cents to currency
      this.sqmPerPackage = parseFloat((_this$dataset$sqmPerP = this.dataset.sqmPerPackage) !== null && _this$dataset$sqmPerP !== void 0 ? _this$dataset$sqmPerP : "0");
    }
  }, {
    key: "rerenderComponent",
    value: function () {
      var _rerenderComponent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(variantId) {
        var productUrl, url, response, text, doc, newComponent, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              productUrl = this.producturl;
              if (productUrl) {
                _context.n = 1;
                break;
              }
              console.warn("FlooringCalculator reinit: missing product URL");
              return _context.a(2);
            case 1:
              url = "".concat(productUrl, "?variant=").concat(variantId);
              _context.n = 2;
              return fetch(url, {
                credentials: "same-origin"
              });
            case 2:
              response = _context.v;
              if (response.ok) {
                _context.n = 3;
                break;
              }
              console.warn("FlooringCalculator reinit: fetch failed", response.status, url);
              return _context.a(2);
            case 3:
              _context.n = 4;
              return response.text();
            case 4:
              text = _context.v;
              doc = new DOMParser().parseFromString(text, "text/html");
              newComponent = doc.querySelector("flooring-calculator");
              if (newComponent) {
                this.replaceWith(newComponent);
              }
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
              console.error("Error re-initializing FlooringCalculator component:", _t);
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[0, 5]]);
      }));
      function rerenderComponent(_x) {
        return _rerenderComponent.apply(this, arguments);
      }
      return rerenderComponent;
    }()
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this2 = this;
      document.addEventListener("on:variant:change", function (event) {
        var customEvent = event;
        var variant = customEvent.detail.variant;
        if (variant && variant.id) {
          _this2.rerenderComponent(variant.id.toString());
        }
      });
      if (this.sqmFloor && this.totalAmountFloor) {
        this.sqmFloor.addEventListener("change", this.updateFlooring);
        if (this.input) {
          this.input.addEventListener("keyup", function () {
            _this2.updateFlooring();
          });
        }
        this.inputButtons.forEach(function (button) {
          button.addEventListener("click", _this2.handleInputButtonClick);
        });
      }
    }
  }, {
    key: "handleInputButtonClick",
    value: function handleInputButtonClick(evt) {
      var button = evt.currentTarget;
      if (!this.input) return;
      var inputVal = parseInt(this.input.value, 10);
      if (button.classList.contains("add")) {
        inputVal += 1;
      } else if (button.classList.contains("remove") && inputVal > 1) {
        inputVal -= 1;
      }
      this.input.value = inputVal.toString();
      this.updateFlooring();
    }
  }, {
    key: "updateFlooring",
    value: function updateFlooring() {
      if (!this.sqmFloor || !this.packageAmount || !this.totalAmountFloor) return;
      var sqmValue = parseFloat(this.sqmFloor.value);
      var packageValue = parseFloat(this.packageAmount.value);
      var totalAmountCalc = sqmValue / packageValue;
      var totalAmountCalcRoundedUp = Math.ceil(totalAmountCalc);
      // Update package text (singular/plural)
      if (this.amountPackages) {
        this.amountPackages.innerText = totalAmountCalcRoundedUp > 1 ? "".concat(this.amountPackagesText, "r") : this.amountPackagesText;
      }
      // Update total amount
      this.totalAmountFloor.value = totalAmountCalcRoundedUp.toString();
      if (this.packageTotal) {
        this.packageTotal.innerHTML = totalAmountCalcRoundedUp.toString();
      }
      // Calculate price
      if (this.pricePackageOutput && this.packagePrice > 0) {
        var totalPriceCalc = totalAmountCalcRoundedUp * this.packagePrice;
        var totalPriceFormatted = totalPriceCalc.toLocaleString("da-DK", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        this.pricePackageOutput.innerHTML = "".concat(totalPriceFormatted, " kr");
      }
      // Calculate total sqm
      if (this.amountSqm) {
        var amountSqmCalc = (packageValue * totalAmountCalcRoundedUp).toFixed(2);
        var amountSqmFormatted = amountSqmCalc.replace(".", ",");
        this.amountSqm.innerHTML = "".concat(amountSqmFormatted, " m<sup>2</sup>");
      }
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _this3 = this;
      if (this.sqmFloor) {
        this.sqmFloor.removeEventListener("change", this.updateFlooring);
      }
      this.inputButtons.forEach(function (button) {
        button.removeEventListener("click", _this3.handleInputButtonClick);
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ },

/***/ "./resources/scripts/components/Consent/Consent.ts"
/*!*********************************************************!*\
  !*** ./resources/scripts/components/Consent/Consent.ts ***!
  \*********************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Consent)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Consent Component
//
// This class manages user consent tracking and interaction with Shopify's consent-tracking API.
// It includes methods for initializing consent features, handling consent updates, and interacting
// with Shopify's privacy settings.
//
// Key Functionalities:
// - `init()`: Loads Shopify's consent-tracking API and initializes the consent component.
// - `initConsentComponent()`: Sets up event listeners for consent actions, such as recalling consent preferences.
// - `handleConsentUpdate(state: string)`: Updates consent settings based on the user's current preferences.
//   - Parameters:
//     - `state`: A string representing the consent state ("granted", "denied", etc.).
// - `checkConsentBannerInteraction()`: Verifies if the user has interacted with the consent banner.
// - `gtag(...args)`: Pushes consent-related events to the Google Tag Manager data layer.
// - `recallConsent()`: Displays the privacy banner to allow users to update their consent preferences.
// - `logConsent(consentSettings: object)`: Logs the user's consent preferences to a database or analytics tool.
//
// Dependencies:
// - `window.dataLayer`: Required for Google Consent Mode V2 integration.
// - Shopify Customer Privacy Banner: Must be enabled in the Shopify admin panel.
//
// Error Handling:
// - Errors in loading Shopify features (e.g., API initialization failures) are logged to the console without blocking the process.
//
// Extensibility:
// - Support additional consent categories or analytics tools by extending `handleConsentUpdate` and other methods.
// - Update `logConsent` to integrate with custom databases or third-party analytics platforms as needed.
//
// Notes:
// - Local storage is used to persist consent settings across sessions.
// Usage Example:
// 1. Import the `Consent` class and initialize it in your application:
// ---- import Consent from './scripts/components/Consent/Consent';
// ---- const consent = new Consent();
// ---- consent.init();
//
// 2. To enable the recall consent feature, add an element with the ID "recall-consent" to the DOM:
// ---- <a href="#" id="recall-consent"></a>
//
// 3. Add Locales: en: "change_cookie_settings": "Change your cookie settings", da: "change_cookie_settings": "Tilpas dine cookie-indstillinger",
var Consent = /*#__PURE__*/function () {
  // declare dataLayer
  function Consent() {
    _classCallCheck(this, Consent);
    this.init = this.init.bind(this);
    this.handleConsentUpdate = this.handleConsentUpdate.bind(this);
    this.checkConsentBannerInteraction = this.checkConsentBannerInteraction.bind(this);
    this.gtag = this.gtag.bind(this);
    this.recallConsent = this.recallConsent.bind(this);
  }
  return _createClass(Consent, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this = this;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              window.Shopify.loadFeatures([{
                name: "consent-tracking-api",
                version: "0.1"
              }], function (error) {
                if (error) {
                  // eslint-disable-next-line no-console
                  console.error("Error loading features: ", error);
                  return;
                }
                // eslint-disable-next-line no-console
                console.log("Consent tracking API loaded");
                _this.initConsentComponent();
              });
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "initConsentComponent",
    value: function () {
      var _initConsentComponent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this2 = this;
        var recallConsentElement;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              window.dataLayer = window.dataLayer || [];
              document.addEventListener("visitorConsentCollected", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      _this2.handleConsentUpdate("update");
                    case 1:
                      return _context2.a(2);
                  }
                }, _callee2);
              })));
              recallConsentElement = document.getElementById("recall-consent");
              if (recallConsentElement) {
                recallConsentElement.addEventListener("click", function (event) {
                  event.preventDefault();
                  _this2.recallConsent();
                });
              }
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      function initConsentComponent() {
        return _initConsentComponent.apply(this, arguments);
      }
      return initConsentComponent;
    }()
  }, {
    key: "handleConsentUpdate",
    value: function () {
      var _handleConsentUpdate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(state) {
        var visitorConsent, consent;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return window.Shopify.customerPrivacy.currentVisitorConsent();
            case 1:
              visitorConsent = _context4.v;
              consent = {
                functionality_storage: "granted",
                analytics_storage: visitorConsent.analytics === "yes" ? "granted" : "denied",
                personalization_storage: visitorConsent.analytics === "yes" ? "granted" : "denied",
                ad_storage: visitorConsent.marketing === "yes" ? "granted" : "denied",
                ad_user_data: visitorConsent.marketing === "yes" ? "granted" : "denied",
                ad_personalization: visitorConsent.marketing === "yes" ? "granted" : "denied",
                wait_for_update: 3000
              };
              this.gtag("consent", state, consent);
              // set local Storage for consent settings for further use on other pages or after page
              localStorage.setItem("consentSettings", JSON.stringify(consent));
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function handleConsentUpdate(_x) {
        return _handleConsentUpdate.apply(this, arguments);
      }
      return handleConsentUpdate;
    }() /* eslint-disable */
  }, {
    key: "checkConsentBannerInteraction",
    value: (function () {
      var _checkConsentBannerInteraction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var visitorConsent;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return window.Shopify.customerPrivacy.currentVisitorConsent();
            case 1:
              visitorConsent = _context5.v;
              if (!(visitorConsent.preferences === "" && visitorConsent.analytics === "" && visitorConsent.marketing === "")) {
                _context5.n = 2;
                break;
              }
              return _context5.a(2, false);
            case 2:
              return _context5.a(2, true);
          }
        }, _callee5);
      }));
      function checkConsentBannerInteraction() {
        return _checkConsentBannerInteraction.apply(this, arguments);
      }
      return checkConsentBannerInteraction;
    }()
    /* eslint-disable */
    /* eslint-disable */
    )
  }, {
    key: "gtag",
    value: function gtag() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      window.dataLayer.push(arguments);
    }
    /* eslint-enable */
    /* eslint-disable */
  }, {
    key: "recallConsent",
    value: (function () {
      var _recallConsent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              window.privacyBanner.showPreferences();
            case 1:
              return _context6.a(2);
          }
        }, _callee6);
      }));
      function recallConsent() {
        return _recallConsent.apply(this, arguments);
      }
      return recallConsent;
    }())
  }]);
}();


/***/ },

/***/ "./resources/scripts/components/Sample.ts"
/*!************************************************!*\
  !*** ./resources/scripts/components/Sample.ts ***!
  \************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Sample)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Sample = /*#__PURE__*/function (_HTMLElement) {
  function Sample() {
    var _this;
    _classCallCheck(this, Sample);
    _this = _callSuper(this, Sample);
    _defineProperty(_this, "addButton", void 0);
    _defineProperty(_this, "loader", void 0);
    _defineProperty(_this, "errorMessage", void 0);
    _defineProperty(_this, "successMessage", void 0);
    _defineProperty(_this, "producturl", null);
    _defineProperty(_this, "sampleVariantId", null);
    _defineProperty(_this, "loadingText", "Tilføjer...");
    _defineProperty(_this, "sampleParentName", "");
    _this.handleAddToCart = _this.handleAddToCart.bind(_this);
    _this.initializeElements = _this.initializeElements.bind(_this);
    _this.addEventListeners = _this.addEventListeners.bind(_this);
    return _this;
  }
  _inherits(Sample, _HTMLElement);
  return _createClass(Sample, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.initializeElements();
      this.addEventListeners();
    }
  }, {
    key: "initializeElements",
    value: function initializeElements() {
      var _this$dataset$product, _this$dataset$sampleV, _this$dataset$loading, _this$dataset$sampleP;
      this.addButton = this.querySelector(".js-add-sample");
      this.loader = this.querySelector(".js-sample-loader");
      this.errorMessage = this.querySelector(".js-sample-error");
      this.successMessage = this.querySelector(".js-sample-success");
      this.producturl = (_this$dataset$product = this.dataset.producturl) !== null && _this$dataset$product !== void 0 ? _this$dataset$product : null;
      this.sampleVariantId = (_this$dataset$sampleV = this.dataset.sampleVariantId) !== null && _this$dataset$sampleV !== void 0 ? _this$dataset$sampleV : null;
      this.loadingText = (_this$dataset$loading = this.dataset.loadingText) !== null && _this$dataset$loading !== void 0 ? _this$dataset$loading : "Tilføjer...";
      this.sampleParentName = (_this$dataset$sampleP = this.dataset.sampleParentName) !== null && _this$dataset$sampleP !== void 0 ? _this$dataset$sampleP : "";
    }
  }, {
    key: "rerenderComponent",
    value: function () {
      var _rerenderComponent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(variantId) {
        var productUrl, url, response, text, doc, newComponent, newSampleId, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              productUrl = this.producturl;
              if (productUrl) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              url = "".concat(productUrl, "?variant=").concat(variantId);
              _context.n = 2;
              return fetch(url, {
                credentials: "same-origin"
              });
            case 2:
              response = _context.v;
              if (response.ok) {
                _context.n = 3;
                break;
              }
              return _context.a(2);
            case 3:
              _context.n = 4;
              return response.text();
            case 4:
              text = _context.v;
              doc = new DOMParser().parseFromString(text, "text/html");
              newComponent = doc.querySelector("sample-upsell");
              if (newComponent) {
                // Replace the entire component's innerHTML with the new content
                this.innerHTML = newComponent.innerHTML;
                // Update data attributes
                newSampleId = newComponent.dataset.sampleVariantId;
                if (newSampleId) {
                  this.dataset.sampleVariantId = newSampleId;
                } else {
                  delete this.dataset.sampleVariantId;
                }
                // Re-initialize elements and event listeners
                this.initializeElements();
                this.addButtonListener();
              }
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[0, 5]]);
      }));
      function rerenderComponent(_x) {
        return _rerenderComponent.apply(this, arguments);
      }
      return rerenderComponent;
    }()
  }, {
    key: "addButtonListener",
    value: function addButtonListener() {
      // Remove old listener if it exists
      if (this.addButton) {
        this.addButton.removeEventListener("click", this.handleAddToCart);
      }
      // Re-query for button and add listener
      this.addButton = this.querySelector(".js-add-sample");
      if (this.addButton) {
        this.addButton.addEventListener("click", this.handleAddToCart);
      }
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this2 = this;
      document.addEventListener("on:variant:change", function (event) {
        var customEvent = event;
        var variant = customEvent.detail.variant;
        if (variant && variant.id) {
          _this2.rerenderComponent(variant.id.toString());
        }
      });
      this.addButtonListener();
    }
  }, {
    key: "handleAddToCart",
    value: function () {
      var _handleAddToCart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(evt) {
        var _this3 = this;
        var formData, response, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              evt.preventDefault();
              if (!(!this.sampleVariantId || !this.addButton)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              // Show loader, hide messages
              this.setLoadingState(true);
              this.hideMessages();
              _context2.p = 2;
              formData = {
                items: [{
                  id: this.sampleVariantId,
                  quantity: 1,
                  properties: {
                    "Prøve af": this.sampleParentName
                  }
                }]
              };
              _context2.n = 3;
              return fetch("/cart/add.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify(formData)
              });
            case 3:
              response = _context2.v;
              if (response.ok) {
                _context2.n = 4;
                break;
              }
              throw new Error("Failed to add to cart");
            case 4:
              // Show success message
              this.showSuccess();
              // Dispatch cart update event
              document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh", {
                bubbles: true
              }));
              // Hide success message after 3 seconds
              setTimeout(function () {
                _this3.hideMessages();
              }, 3000);
              _context2.n = 6;
              break;
            case 5:
              _context2.p = 5;
              _t2 = _context2.v;
              this.showError();
            case 6:
              _context2.p = 6;
              this.setLoadingState(false);
              return _context2.f(6);
            case 7:
              return _context2.a(2);
          }
        }, _callee2, this, [[2, 5, 6, 7]]);
      }));
      function handleAddToCart(_x2) {
        return _handleAddToCart.apply(this, arguments);
      }
      return handleAddToCart;
    }()
  }, {
    key: "setLoadingState",
    value: function setLoadingState(isLoading) {
      var _this$addButton;
      if (this.addButton) {
        this.addButton.disabled = isLoading;
      }
      if (this.loader) {
        this.loader.style.display = isLoading ? "inline-block" : "none";
      }
      // Update button text
      var buttonText = (_this$addButton = this.addButton) === null || _this$addButton === void 0 ? void 0 : _this$addButton.querySelector(".js-button-text");
      if (buttonText) {
        if (isLoading) {
          buttonText.textContent = this.loadingText;
        } else {
          var _this$addButton2;
          // Restore original text from data attribute or default
          var originalText = (_this$addButton2 = this.addButton) === null || _this$addButton2 === void 0 ? void 0 : _this$addButton2.dataset.originalText;
          if (originalText) {
            buttonText.textContent = originalText;
          }
        }
      }
    }
  }, {
    key: "hideMessages",
    value: function hideMessages() {
      if (this.errorMessage) {
        this.errorMessage.style.display = "none";
      }
      if (this.successMessage) {
        this.successMessage.style.display = "none";
      }
    }
  }, {
    key: "showSuccess",
    value: function showSuccess() {
      if (this.successMessage) {
        this.successMessage.style.display = "block";
      }
    }
  }, {
    key: "showError",
    value: function showError() {
      if (this.errorMessage) {
        this.errorMessage.style.display = "block";
      }
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (this.addButton) {
        this.addButton.removeEventListener("click", this.handleAddToCart);
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ },

/***/ "./resources/styles/app.css"
/*!**********************************!*\
  !*** ./resources/styles/app.css ***!
  \**********************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Check if module exists (development only)
/******/ 		if (__webpack_modules__[moduleId] === undefined) {
/******/ 			var e = new Error("Cannot find module '" + moduleId + "'");
/******/ 			e.code = 'MODULE_NOT_FOUND';
/******/ 			throw e;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/shopify-theme/assets/edition": 0,
/******/ 			"shopify-theme/assets/edition": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkviborggulvforum"] = self["webpackChunkviborggulvforum"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["shopify-theme/assets/edition"], () => (__webpack_require__("./resources/app.ts")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["shopify-theme/assets/edition"], () => (__webpack_require__("./resources/styles/app.css")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;